module.exports = __webpack_public_path__ + "img/Icon_Informes_del_caso.469ad85d.svg";